// extracted by mini-css-extract-plugin
module.exports = {"bulletList":"styles-module__bulletList___Olyko"};